import { render, staticRenderFns } from "./ReleaseChildOrders.vue?vue&type=template&id=5fad457f"
import script from "./ReleaseChildOrders.vue?vue&type=script&lang=js"
export * from "./ReleaseChildOrders.vue?vue&type=script&lang=js"
import style0 from "./ReleaseChildOrders.vue?vue&type=style&index=0&id=5fad457f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports